import { Row as AntRow, Col as AntCol, Radio as AntRadio } from 'antd';
import styled, { css } from 'styled-components';
import { Modal as ModalAtom } from 'components/atoms/modal';
import { Progress } from 'components/atoms/progress';
import {
  Caption01,
  ProductiveHeading04,
  ProductiveHeading05,
  ProductiveHeading07,
} from 'components/styles';

export const Wrapper = styled(AntRow)`
  padding: 0;
  min-height: 95vh;
  height: 95vh;
`;

export const StyledCol = styled(AntCol)`
  height: 100%;
  padding: var(--spacing-07);
`;

export const LeftColumn = styled(StyledCol).attrs({ flex: '240px' })`
  border-right: 1px solid var(--border-color);
  padding: var(--spacing-07) 0;
`;

export const Main = styled(StyledCol).attrs({ flex: 'auto' })`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: auto;
  padding: 0;

  .ant-form {
    padding: var(--spacing-05) var(--spacing-07);
    margin-bottom: var(--layout-01);
  }
`;

export const Row = styled(AntRow).attrs({ gutter: 24 })``;
export const Col = styled(AntCol).attrs((props) => {
  return { span: 12, ...props };
})`
  min-height: 0px;
`;
export const Modal = styled(ModalAtom)`
  .ant-modal-body {
    padding: 0;
  }
  padding: 0;
`;

export const Title = styled.div`
  ${ProductiveHeading07};
  width: calc(100% - 48px);
`;

export const Heading = styled.h1`
  ${ProductiveHeading04};
  margin-bottom: var(--layout-04);
`;

export const Radio = styled(AntRadio)`
  &:not(:last-child) {
    margin-bottom: var(--layout-01);
  }
`;

export const Caption = styled.div`
  ${Caption01};
  margin-top: var(--spacing-03);
`;

export const PlaceholderLabel = styled.label`
  display: flex;
  align-items: center;
`;

export const PlaceholderMeta = styled.div`
  margin-left: var(--spacing-03);
  display: flex;
  flex-direction: column;
`;

export const PlaceholderTaskCount = styled.span`
  color: var(--gray-80);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-02);
`;

export const Label = styled.div`
  padding-top: var(--spacing-04);
`;

export const PlaceholderSectionHeading = styled.div`
  ${Caption01};
  color: var(--gray-50);
  margin-bottom: var(--spacing-05);
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  > span {
    flex-shrink: 0;
  }
  &:after {
    content: '';
    width: 100%;
    border-bottom: 1px solid var(--border-color);
  }
`;

export const HeadingWrapper = styled.div`
  ${ProductiveHeading05};
`;

export const Header = styled.div`
  flex: 0 1 auto;
  margin-top: var(--spacing-05);
  padding: 0 var(--spacing-07);
`;

export const TabsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-07);
`;
export const Tab = styled.div<{ isSelected?: boolean }>`
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  cursor: pointer;
  padding-left: var(--spacing-05);
  color: var(--gray-80);
  &:hover {
    color: var(--blue-60);
  }

  ${({ isSelected }) =>
    isSelected
      ? css`
          svg {
            color: var(--blue-60);
          }
        `
      : ''};
`;

export const ContentWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-flow: column;
`;

export const FormWrapper = styled.div`
  flex: 1 1 auto;
  overflow-y: scroll;
`;

export const FooterWrapper = styled.div`
  padding: var(--spacing-05);
  flex: 0 1 auto;
`;

export const StyledProgress = styled(Progress)`
  &::after {
    content: '';
    position: absolute;
    width: 32px;
    height: 1px;
    bottom: 8px;
    background-color: var(--coolest-gray-20);
  }

  &::before {
    content: '';
    position: absolute;
    width: 32px;
    height: 1px;
    bottom: 8px;
    background-color: var(--coolest-gray-20);
    left: -32px;
  }
`;
